import React, { Component } from 'react';
import PropTypes from 'prop-types';
// This is a copy of https://github.com/CassetteRocks/react-infinite-scroller with https://github.com/CassetteRocks/react-infinite-scroller/pull/38/files merged
class InfiniteScroll extends Component {
    constructor(props) {
        super(props);
        this.detachScrollListener = () => { };
        this.scrollListener = this.scrollListener.bind(this);
    }
    componentDidMount() {
        var _a, _b;
        this.pageLoaded = this.props.pageStart;
        this.attachScrollListener();
        if (this.props.initialLoad) {
            this.scrollListener();
        }
        // when component mounts try to load more only when initial data was already rendered
        else if (((_a = this.props.data) === null || _a === void 0 ? void 0 : _a.length) && this.props.hasMore) {
            ((_b = this.scrollComponent) === null || _b === void 0 ? void 0 : _b.scrollHeight) && this.scrollListener();
        }
    }
    componentDidUpdate(prevProps) {
        var _a, _b, _c;
        this.attachScrollListener();
        // scroll element might be not scrollable - trigger scroll listener when new data changes the scroll element height
        if (((_a = prevProps.data) === null || _a === void 0 ? void 0 : _a.length) !== ((_b = this.props.data) === null || _b === void 0 ? void 0 : _b.length) &&
            this.props.hasMore) {
            // To avoid infinite loop of `loadMore` in `jsdom` we require the scroll element to have height before we trigger `scrollListener` as a reaction to new `props.data`.
            ((_c = this.scrollComponent) === null || _c === void 0 ? void 0 : _c.scrollHeight) && this.scrollListener();
        }
    }
    render() {
        const { children, hasMore, loader, scrollElement, dataHook } = this.props;
        let ref;
        if (scrollElement) {
            ref = () => (this.scrollComponent = scrollElement);
        }
        else {
            ref = node => (this.scrollComponent = node);
        }
        return React.createElement('div', { ref, 'data-hook': dataHook }, children, hasMore && (loader || this._defaultLoader));
    }
    calculateTopPosition(el) {
        if (!el) {
            return 0;
        }
        return el.offsetTop + this.calculateTopPosition(el.offsetParent);
    }
    scrollListener() {
        const el = this.scrollComponent;
        let offset;
        if (this.props.scrollElement) {
            if (this.props.isReverse) {
                offset = el.scrollTop;
            }
            else {
                offset = el.scrollHeight - el.scrollTop - el.clientHeight;
            }
        }
        else if (this.props.useWindow) {
            const scrollTop = window.pageYOffset !== undefined
                ? window.pageYOffset
                : (document.documentElement ||
                    document.body.parentNode ||
                    document.body).scrollTop;
            if (this.props.isReverse) {
                offset = scrollTop;
            }
            else {
                offset =
                    this.calculateTopPosition(el) +
                        el.offsetHeight -
                        scrollTop -
                        window.innerHeight;
            }
        }
        else if (this.props.isReverse) {
            offset = el.parentNode.scrollTop;
        }
        else {
            offset =
                el.scrollHeight - el.parentNode.scrollTop - el.parentNode.clientHeight;
        }
        if (offset < Number(this.props.threshold)) {
            this.detachScrollListener();
            // Call loadMore after detachScrollListener to allow for non-async loadMore functions
            if (typeof this.props.loadMore === 'function' && this.props.hasMore) {
                this.props.loadMore((this.pageLoaded += 1));
            }
        }
    }
    attachScrollListener() {
        this.detachScrollListener();
        if (!this.props.hasMore) {
            return;
        }
        let scrollEl = window;
        if (this.props.scrollElement) {
            scrollEl = this.scrollComponent;
        }
        else if (this.props.useWindow === false) {
            scrollEl = this.scrollComponent.parentNode;
        }
        scrollEl.addEventListener('scroll', this.scrollListener);
        scrollEl.addEventListener('resize', this.scrollListener);
        this.detachScrollListener = () => {
            scrollEl.removeEventListener('scroll', this.scrollListener);
            scrollEl.removeEventListener('resize', this.scrollListener);
            this.detachScrollListener = () => { };
        };
    }
    componentWillUnmount() {
        this.detachScrollListener();
    }
    // Set a default loader for all your `InfiniteScroll` components
    setDefaultLoader(loader) {
        this._defaultLoader = loader;
    }
}
InfiniteScroll.propTypes = {
    hasMore: PropTypes.bool,
    initialLoad: PropTypes.bool,
    data: PropTypes.array,
    loadMore: PropTypes.func.isRequired,
    pageStart: PropTypes.number,
    threshold: PropTypes.number,
    useWindow: PropTypes.bool,
    isReverse: PropTypes.bool,
    scrollElement: PropTypes.object,
    children: PropTypes.node,
    loader: PropTypes.node,
};
InfiniteScroll.defaultProps = {
    hasMore: false,
    initialLoad: true,
    pageStart: 0,
    threshold: 250,
    useWindow: true,
    isReverse: false,
    scrollElement: null,
};
export default InfiniteScroll;
//# sourceMappingURL=InfiniteScroll.js.map